<template>
  <div class="app-single-topup-amount-btn-selector grid">
    <slot name="txtBefore"></slot>
    <div class="button-wrapper" v-for="amounts in availableAmounts" v-bind:key="amounts.value">
      <button @click="showModal(amounts)" name="amount" class="button button--primary">
        {{ amounts.text }}
      </button>
    </div>
  </div>
</template>

<script>
import preFilledInput from '@/mixins/preFilledInput'
import slotProxy from '@/mixins/slotProxy'

export const stepName = 'amountSelect'

export default {
  name: 'SingleTopUpAmountBtnSelector',
  data: function() {
    return {
      modalShow: false,
      selectedAmount: [],
      loading: false
    }
  },
  mixins: [preFilledInput('amount', 'defaultAmount'), slotProxy()],
  methods: {
    currencyFormater(value) {
      return this.$config.calendar.formatter.shortCurrencyFormatter.format(value / 100)
    },
    showModal(amount) {
      this.$emit('showmodal', amount)
    }
  },
  computed: {
    availableAmounts: function() {
      return this.amounts.map(cents => {
        return {
          value: cents,
          text: this.currencyFormater(cents)
        }
      })
    }
  },
  props: {
    amounts: {
      type: Array,
      required: true
    },
    defaultAmount: {
      type: Number,
      default: 1000
    },
    payment: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
